import {
  GET_NOTES_SUCCEED,
  GET_NOTES_ERROR,
  GET_NOTE_SUCCEED,
  GET_NOTE_ERROR,
  DELETE_NOTE_SUCCEED,
  DELETE_NOTE_ERROR,
  EDIT_NOTE_SUCCEED,
  EDIT_NOTE_ERROR,
  CREATE_NOTE_SUCCEED,
  CREATE_NOTE_ERROR,
  LOADING_STATE
} from './types';

const INITIAL_STATE = {
  notes: [],
  note: {},
  noteIsDeleted: false,
  noteIsUpdated: false,
  noteIsSaved: false,
  loading: false
};

export default function(state = INITIAL_STATE, action) {
  if (action.type === GET_NOTES_SUCCEED) {
    return {
      ...state,
      notes: action.payload,
      noteIsDeleted: false,
      noteIsSaved: false,
      loading: false
    };
  } else if (action.type === GET_NOTES_ERROR) {
    return { ...state, error: action.payload, loading: false };
  } else if (action.type === GET_NOTE_SUCCEED) {
    return {
      ...state,
      note: action.payload,
      noteIsDeleted: false,
      noteIsUpdated: false,
      noteIsSaved: false,
      loading: false
    };
  } else if (action.type === GET_NOTE_ERROR) {
    return { ...state, error: action.payload, loading: false };
  } else if (action.type === DELETE_NOTE_SUCCEED) {
    return { ...state, note: null, noteIsDeleted: true };
  } else if (action.type === DELETE_NOTE_ERROR) {
    return { ...state, error: action.payload, noteIsDeleted: false };
  } else if (action.type === EDIT_NOTE_SUCCEED) {
    return { ...state, noteIsUpdated: true };
  } else if (action.type === EDIT_NOTE_ERROR) {
    return { ...state, error: action.payload, noteIsUpdated: false };
  } else if (action.type === CREATE_NOTE_SUCCEED) {
    return { ...state, noteIsSaved: true };
  } else if (action.type === CREATE_NOTE_ERROR) {
    return { ...state, error: action.payload, noteIsSaved: false };
  } else if (action.type === LOADING_STATE) {
    return { ...state, loading: true };
  } else {
    return state;
  }
}
